import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const fetchJobDescriptionList = createAsyncThunk("fetchJobDescriptionList", async ({ page, filters, limit }, { rejectWithValue }) => {
	const params = new URLSearchParams();

	if (page) params.append("page", page);
	if (limit) params.append("limit", limit);

	Object.entries(filters || {}).forEach(([key, value]) => {
		if (value !== undefined && value !== null && value !== "") {
			params.append(key, value);
		}
	});
	try {
		const response = await axiosHttp.get(`/jdoc/getjdesc`, { params });
		return response.data.data;
	} catch (error) {
		return rejectWithValue(error?.response?.data?.message || "Something went wrong");
	}
});

const JobDescriptionListSlice = createSlice({
	name: "JobDescriptionListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},
	extraReducers: (builder) => {
		builder.addCase(fetchJobDescriptionList.pending, (state) => {
			state.isLoading = true;
			state.error = null;
		});
		builder.addCase(fetchJobDescriptionList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.error = null;
		});
		builder.addCase(fetchJobDescriptionList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default JobDescriptionListSlice.reducer;
